import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { fechaHora } from '@/shared/utilidades/formato'

import { useAvisos, useMarcarLeido } from './useAvisos'
import { IconoCampana } from '@/shared/ui/Iconos/Iconos'

import estilos from './CampanaAvisos.module.css'

/**
 * Los avisos.
 *
 * Lo que cada quien tiene que enterarse sin que nadie se lo diga por teléfono:
 * al operario que se le acabó el tiempo de su orden, al Gerente operativo que
 * alguien pidió más.
 */
export function CampanaAvisos() {
  const navegar = useNavigate()
  const { avisos, sinLeer } = useAvisos()
  const marcar = useMarcarLeido()
  const [abierto, setAbierto] = useState(false)
  const caja = useRef<HTMLDivElement>(null)

  // Se cierra al tocar por fuera: un panel que se queda abierto tapando la
  // pantalla es peor que no tenerlo.
  useEffect(() => {
    if (!abierto) return

    function alTocar(evento: MouseEvent) {
      if (caja.current && !caja.current.contains(evento.target as Node)) setAbierto(false)
    }

    document.addEventListener('mousedown', alTocar)
    return () => document.removeEventListener('mousedown', alTocar)
  }, [abierto])

  function abrirAviso(aviso: (typeof avisos)[number]) {
    if (aviso.leido_en === null) marcar.mutate(aviso.id)
    setAbierto(false)

    // Los sobrantes se verifican en su sección, no en la orden (0310).
    if (aviso.tipo === 'sobrantes_reportados') {
      navegar('/sobrantes')
      return
    }

    // El aviso es de una orden de trabajo, pero la pantalla que existe es la
    // de su orden de servicio: se llega por la matriz.
    if (aviso.documento_numero) navegar(`/ordenes?buscar=${aviso.documento_numero}`)
  }

  return (
    <div className={estilos.zona} ref={caja}>
      <button
        type="button"
        className={estilos.campana}
        onClick={() => setAbierto(!abierto)}
        aria-label={sinLeer > 0 ? `${sinLeer} avisos sin leer` : 'Avisos'}
      >
        {/* Icono del mismo juego que el menú. El emoji venía con el estilo
            del sistema operativo: en Windows sale amarillo y macizo, y era lo
            único de la barra que no seguía la línea del resto. */}
        <IconoCampana />
        {sinLeer > 0 && <span className={estilos.contador}>{sinLeer}</span>}
      </button>

      {abierto && (
        <div className={estilos.panel}>
          {avisos.length === 0 ? (
            <p className={estilos.vacio}>Sin avisos.</p>
          ) : (
            <ul className={`${estilos.lista} desplazable`}>
              {avisos.map((aviso) => (
                <li key={aviso.id}>
                  <button
                    type="button"
                    className={`${estilos.aviso} ${
                      aviso.leido_en === null ? estilos.sinLeer : ''
                    } ${estilos[aviso.tipo] ?? ''}`}
                    onClick={() => abrirAviso(aviso)}
                  >
                    <span className={estilos.titulo}>{aviso.titulo}</span>
                    {aviso.cuerpo && <span className={estilos.cuerpo}>{aviso.cuerpo}</span>}
                    <span className={estilos.cuando}>{fechaHora(aviso.creado_en)}</span>
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  )
}
